import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

class EchoService {
private static instance: any | null= null

    static init(): any {
        if (!this.instance) {
            // Initialize Laravel Echo
            ;(window as any).Pusher = Pusher
            this.instance = new Echo({
                broadcaster: 'pusher',
                key: import.meta.env.VITE_WEB_SOCKET_KEY ?? null,
                wsHost: import.meta.env.VITE_WEB_SOCKET_HOST ?? null,
                wsPort: import.meta.env.VITE_WEB_SOCKET_PORT ?? null,
                wssPort: import.meta.env.VITE_WEB_SOCKET_PORT ?? null,
                cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? '',
                forceTLS: false,
                encrypted: true,
                disableStats: true,
                enabledTransports: ['ws', 'wss']
            })

            ;(window as any).Echo = this.instance
        }
        
        return this.instance
    }

    static disconnect(): void {
        if (this.instance) {
            this.instance.disconnect()
            this.instance = null
            delete (window as any).Echo
        }
    }
}

export default EchoService